import { PencilIcon, Share2Icon } from 'lucide-react'
import type { ReactNode } from 'react'

import { ComingSoonBadge } from '@/components/atoms/coming-soon-badge.atom'
import { DropdownMenuGroup, DropdownMenuItem } from '@/components/ui/dropdown-menu'

import type { ChatItemActions } from './sidebar-item-actions.interface'

interface SidebarChatActionsPrimaryProps {
  chatId: string
  actions: ChatItemActions
}

export const SidebarChatActionsPrimary = ({
  chatId,
  actions,
}: SidebarChatActionsPrimaryProps): ReactNode => (
  <DropdownMenuGroup>
    <DropdownMenuItem disabled className="sidebar-chat-share-action">
      <div className="relative flex items-center gap-2">
        <Share2Icon className="size-4" />
        <span>Share</span>
        <ComingSoonBadge className="-top-2 -right-6" />
      </div>
    </DropdownMenuItem>
    <DropdownMenuItem onClick={() => actions.onRename(chatId)}>
      <PencilIcon />
      Rename
    </DropdownMenuItem>
  </DropdownMenuGroup>
)
